'use client';

import { Button } from '@finn/design-system/atoms/button';
import { Input } from '@finn/design-system/atoms/input';
import { VisibilityFilled } from '@finn/design-system/icons/visibility-filled';
import { VisibilityOffOutlined } from '@finn/design-system/icons/visibility-off-outlined';
import { useCallback, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type PasswordInputWithToggleProps = {
  name: string;
  label: string;
  autoComplete?: string;
  error?: string;
};

export const PasswordInputWithToggle = ({
  name,
  label,
  autoComplete = 'current-password',
}: PasswordInputWithToggleProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const { control } = useFormContext();

  const toggleVisibility = useCallback(() => {
    setIsVisible((prev) => !prev);
  }, []);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Input
          {...field}
          type={isVisible ? 'text' : 'password'}
          autoComplete={autoComplete}
          label={label}
          error={fieldState.error?.message}
          endAdornment={
            field.value ? (
              <Button
                variant="icon"
                size="sm"
                type="button"
                aria-label={
                  isVisible ? 'Passwort verbergen' : 'Passwort anzeigen'
                }
                className="border-transparent p-0 hover:bg-white hover:fill-black"
                onClick={toggleVisibility}
              >
                {isVisible ? (
                  <VisibilityOffOutlined className="min-w-5" />
                ) : (
                  <VisibilityFilled className="min-w-5" />
                )}
              </Button>
            ) : undefined
          }
        />
      )}
    />
  );
};
